module.exports = "https://coursera_assets.s3.amazonaws.com/images/3992562e0579857ad8985a1bba1c3a0b.png";